module.exports = __webpack_public_path__ + "static/img/5.59252787.jpg";